var tID, cID, defaultView, defaultSelect;
var country = window.Shopify.country;
var isMobile = window.innerWidth < 768;
var hideSuggestion = false;
var sofaFinderBrandClick = null;
var defaultLoadScreen = `<div class="w-full flex ai-center jc-center" style="transform: scale(2.5);height: 500px;"><div class="ps_loading sshow"></div></div>`;
var loadingScreen = document.querySelector(isMobile ? '.predictive-search-results-mobile' : '#predictive-search-results')?.innerHTML;

if (loadingScreen == null) {
    loadingScreen = defaultLoadScreen;
}

function searchFunction(val) {
    const searchTerm = val.trim() || 'default-suggestions';
    loadScreenActive();
    getSearchResults(searchTerm);
}

function getSearchResults(searchTerm) {
    if (!searchTerm) return;
    let isJapanGo = document.documentElement.lang === 'ja';
    if (document.documentElement.lang == 'zh-CN') {
        isJapanGo = true;
    }
    let locale = getLocale();
    const optionFields = searchTerm === 'default-suggestions' ? 'title' : 'variants.sku,variants.title,vendor,title,tag,product_type,body';
    const viewType = isMobile ? '-mobile' : '';
    const url = isJapanGo
        ? `${locale}/search?q=${searchTerm}&view=predictive-template${viewType}`
        : `${locale}/search/suggest?q=${searchTerm}&section_id=predictive-search${viewType}&resources[options][fields]=${optionFields}&resources[type]=product,collection,page,query&resources[limit_scope]=each`;

    clearTimeout(tID);
    tID = setTimeout(() => fetchSearchResults(url, searchTerm, isMobile, isJapanGo), 500);
}

function fetchSearchResults(url, searchTerm, isMobile, isJapanGo) {
    fetch(url)
        .then(response => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
        })
        .then(text => renderResults(text, searchTerm, isMobile, isJapanGo))
        .catch(error => console.error("Error fetching search results:", error));
}

function renderResults(text, searchTerm, isMobile, isJapanGo) {
    const querySelector = isMobile
        ? isJapanGo ? '#autosuggest' : '#shopify-section-predictive-search-mobile'
        : isJapanGo ? '#autosuggest' : '#shopify-section-predictive-search';

    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(querySelector)?.innerHTML;
    const activeSelector = isMobile ? 'predictive-search-mobile' : 'predictive-search';
    const activeSelectorMarkup = isMobile ? '.predictive-search-results-mobile' : '#predictive-search-results';
    const predictiveSearchResults = document.getElementById(activeSelector);
    const predictiveSearchResultsView = document.querySelector(activeSelectorMarkup);

    const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
    var prodResultCount = parseInt(parsedDoc.querySelector(isMobile ? '#productHm .number-box-calc' : '#productH .number-box-calc').innerText);
    if (!isJapanGo) {
        var collResultCount = parseInt(parsedDoc.querySelector(isMobile ? '#collectionHm .number-box' : '#collectionH .number-box').innerText);
    } else { var collResultCount = 0; }
    var pageResultCount = parseInt(parsedDoc.querySelector(isMobile ? '#pageHm .number-box' : '#pageH .number-box').innerText);

    if (predictiveSearchResults?.classList.contains(isMobile ? 'active' : 'show')) {
        predictiveSearchResultsView.innerHTML = resultsMarkup;
    }
    if (!isJapanGo) getSearchCount(searchTerm);

    // Define the options in an array for comparison
    const options = [
        { condition: collResultCount > prodResultCount && collResultCount > pageResultCount, select: 'collectionH', selectMobile: 'collectionHm', view: 'collectionR', viewMobile: 'collectionRm' },
        { condition: pageResultCount > prodResultCount && pageResultCount > collResultCount, select: 'pageH', selectMobile: 'pageHm', view: 'pageR', viewMobile: 'pageRm' },
        { condition: prodResultCount === 0 && collResultCount != 0, select: 'collectionH', selectMobile: 'collectionHm', view: 'collectionR', viewMobile: 'collectionRm' },
        { condition: true, select: 'productH', selectMobile: 'productHm', view: 'productR', viewMobile: 'productRm' }, // Default case
    ];

    // Find the first option where the condition is true
    const bestOption = options.find(option => option.condition);

    // Assign the default select and view based on `isMobile`
    this.defaultSelect = isMobile ? bestOption.selectMobile : bestOption.select;
    this.defaultView = isMobile ? bestOption.viewMobile : bestOption.view;


    if (defaultView && defaultSelect) {
        setDisplay(defaultView, defaultSelect);
    } else {
        setDisplay(isMobile ? 'productRm' : 'productR', isMobile ? 'productHm' : 'productH');
    }

    if (!isMobile) {
        document.querySelectorAll('.terms').forEach(input => input.innerText = searchTerm);
    }

    toggleSuggestions(hideSuggestion && isMobile)
    open();
    
    if (sofaFinderBrandClick) {
        sofaFinderEvents(searchTerm, prodResultCount === 0);
        sofaFinderBrandClick = null;
    }
}

function open() {
    document.querySelector('.predictive-search-results').style.display = 'block';
}

function close() {
    document.querySelector('.predictive-search-results').style.display = 'none';
}

function autofill(text, hideSuggestion = false) {
    this.hideSuggestion = hideSuggestion;
    document.querySelectorAll('#sinput').forEach(input => input.value = text);
    searchFunction(text);
}

function setDisplay(value1, value2) {
    if (!value1.includes("default")) {
        defaultView = value1;
        defaultSelect = value2;
    }

    toggleMultipleClasses('.got_result', 'show', 'hide');
    toggleMultipleClasses('.tab_opt', 'viewed');
    toggleMultipleClasses('.number-box', 'num-selected');
    toggleMultipleClasses('.line-long-1px', 'line-selected');

    document.getElementById(value1)?.classList.add('show');
    document.getElementById(value1)?.classList.remove('hide');
    const section = document.getElementById(value2);

    section?.querySelector('.number-box')?.classList.add('num-selected');
    section?.querySelector('.tab_opt')?.classList.add('viewed');
    section?.querySelector('.line-long-1px')?.classList.add('line-selected');

    if (value1.includes('collection') || value1.includes('page')) {
        toggleMultipleClasses('.search_btn', 'show', 'hide');
    } else {
        toggleMultipleClasses('.search_btn', 'hide');
    }
}

function toggleMultipleClasses(selector, removeClass, addClass = null) {
    document.querySelectorAll(selector).forEach(item => {
        item.classList.remove(removeClass);
        if (addClass) item.classList.add(addClass);
    });
}

function openBar(state) {
    const body = document.querySelector('body');
    const predictiveSearchResultsMobile = document.getElementById('predictive-search-mobile');
    const predictiveSearchResults = document.getElementById('predictive-search');

    if (state === 'close') {
        predictiveSearchResults.classList.remove('show');
        predictiveSearchResultsMobile.classList.remove('active');
        body.style.overflow = 'auto';
    } else {
        const isScreenMobile = window.innerWidth <= 768;
        const headerHeight = document.querySelector('#site-header').offsetHeight;
        document.querySelector('#predictive-search-mobile.mobile-menu-wrapper').style.top = `${headerHeight}px`;

        if (isScreenMobile) {
            body.style.overflow = 'hidden';
            predictiveSearchResultsMobile.classList.toggle('active');
        } else {
            predictiveSearchResults.classList.toggle('show');
        }

        if (predictiveSearchResultsMobile.classList.contains('active') || predictiveSearchResults.classList.contains('show')) {
            if (isPredictiveSearchPopulated()) {
                getSearchResults('default-suggestions');
            }
            document.querySelector('#sinput.predictive-input').focus();
        }
    }
}

function clearInput() {
    if (isPredictiveSearchPopulated()) {
        document.querySelectorAll('#sinput').forEach(input => input.value = "");
        searchFunction('');
    }
    openBar('close');
}

window.addEventListener('resize', () => {
    if (window.innerWidth > 500) openBar('close');
    isMobile = window.innerWidth < 768;
    setDisplay(isMobile ? 'productRm' : 'productR', isMobile ? 'productHm' : 'productH');
    loadingScreen = defaultLoadScreen;
});

function getSearchCount(searchTerm) {
    if (searchTerm === 'default-suggestions') return;

    const url = `/search?q=${searchTerm}&type=product&view=autosuggest`;
    clearTimeout(cID);
    cID = setTimeout(() => {
        fetch(url)
            .then(response => response.text())
            .then(data => {
                const resultsCount = new DOMParser().parseFromString(data, 'text/html').querySelector('#result-count')?.innerText;
                const productNumberBox = document.getElementById(isMobile ? 'prod-count-mobile' : 'prod-count');
                if (productNumberBox) productNumberBox.innerText = resultsCount;
            })
            .catch(error => console.error("Error fetching search count:", error));
    }, 500);
}


function isPredictiveSearchPopulated() {
    return isMobile ? document.querySelector('.pop-box_load') : document.querySelector('.suggestions .ps_loading.sshow');
}

function loadScreenActive() {
    const activeSelector = isMobile ? 'predictive-search-mobile' : 'predictive-search';
    const activeSelectorMarkup = isMobile ? '.predictive-search-results-mobile' : '#predictive-search-results';
    const predictiveSearchResults = document.getElementById(activeSelector);
    const predictiveSearchResultsView = document.querySelector(activeSelectorMarkup);

    if (predictiveSearchResults?.classList.contains(isMobile ? 'active' : 'show')) {
        predictiveSearchResultsView.innerHTML = loadingScreen;
    }
}

function toggleSuggestions(shouldHide) {
    document.querySelectorAll('.suggestions').forEach(e => e.classList.toggle('hide', shouldHide));
    hideSuggestion = false; // Update global state
}